<template>
  <div class="article" :style="{ paddingBottom }">
    <div v-if="enable === 1">
      <div class="view">
        <h1>{{ info.title }}</h1>
        <p class="info">
          {{ info.pushDate | formatDate('YYYY-MM-DD') }}
          &ensp;来源：{{'微课'}}
          &ensp;{{info.author}}
        </p>

        <!-- 富文本主体 -->
        <main v-if="articleBody" v-cut="false">
          <div v-for="(item, index) in articleBody" :key="`a${index}`">
            <article v-if="typeof item === 'string'" v-html="item"/>
            <app-article-audio v-else :source="item.src" :title="info.title" :from="`微课`" type="daily"/>
          </div>
        </main>
        <QrcodeCover class="article-cover" v-if="!hasSubscribed"></QrcodeCover>
        <!-- 统计 -->
        <p class="stat">
          <span>阅读量 {{ info.readCount }}</span>
          <span>
            <img
              :src="(praised && info.praiseCount > 0) ? require('../assets/icons/article-liked-orange.png') : require('../assets/icons/article-like.png')"
              alt="like"
              @click="praise"/>
            <i :style="{ color: praised ? '#FF9C51' : '#979797' }">{{ Math.max(0, info.praiseCount) }}</i>
          </span>
        </p>
      </div>

      <!-- 评论 -->
      <comment
        :list="commentList"
        :total="total"
        @reply="toggleReplyPopup"
        @praise="commentPraise"
      />
      <reply v-if="replying"
        v-model="commentValue"
        placeholder="请输入留言..."
        :cancel="toggleReplyPopup"
        :send="sendComment"
      />
      <hr ref="detector"/>

      <!-- 底部横幅，展示给主动分享用户 -->
      <div v-if="signed === 0 && isSelf === 1" class="share">
        <img class="avatar" :src="user.pic" alt="avatar"/>
        <div class="condition">
          <p>{{user.nickname}}</p>
          <p>已累计成长：{{ info.userLearnDays || 0 }}天</p>
        </div>

        <img class="share-btn" src="../assets/images/article-daily-share-btn.png" alt="share" @click="openShare"/>
      </div>

      <!-- 底部横幅，展示给被分享用户 -->
      <div v-if="isSelf === 0" class="share-notself">
        <dl>
          <dt><img :src="info.shareUserAvatar"/><span>{{ info.shareUserName }}</span></dt>
          <dd>已累计成长 {{ info.userLearnDays }}天</dd>
        </dl>
        <div class="share-notself-right">
          <img class="doc" src="../assets/images/article-notself-bottom-doc.png" alt="qr"/>
          <img class="qr" :src="info.qrCode" alt="qrdata"/>
        </div>
      </div>

      <div v-if="showShare && isSelf === 1" class="cover" @click="closeCover">
        <img id="daily" v-if="!showResult && type === 'daily'" src="../assets/images/article-daily-share-cover.png" alt="share"/>
      </div>

      <div v-if="showResult && showOnceSuccess" class="cover" @click="closeCover">
        <img id="dailyOk" v-if="type === 'daily'" src="../assets/images/article-daily-share-ok.png" alt="ok"/>
        <p id="dailyCount" v-if="type === 'daily'">您已累计传递：{{1}}次</p>
      </div>
    </div>

    <div class="disableArticle vh100" v-if="enable === 0">
      <img src="../assets/images/article-deleted.png"/>
    </div>
  </div>
</template>

<script>
import keys from 'lodash.keys'
import module from '../modules/article'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import formatDate from '../filters/format-timestamp-to-date'
import AppArticleAudio from '../components/Article/Audio'
import marshallArticle from '../lib/marshallArticle'
import AppButton from '../components/UI/Button'
import QrcodeCover from '../components/Article/QrcodeCover'
import * as Comment from '../components/Comment'
import ShareMaker from '../lib/shareMaker'
import rem from '@edu-fe/rem'

export default {
  components: {
    AppArticleAudio,
    AppButton,
    Comment: Comment.CommentArticle,
    Reply: Comment.ReplyPopup,
    QrcodeCover
  },

  data () {
    return {
      enable: -1,
      articleBody: '',
      showShare: false,
      showResult: false,
      replying: false,
      showOnceSuccess: false,

      commentValue: ''
    }
  },

  filters: {
    formatDate
  },

  computed: {
    ...mapState(module.name, keys(module.state)),
    ...mapGetters(module.name, keys(module.getters)),

    paddingBottom () {
      return (!this.isSelf || !this.signed) ? rem.design2rem(120) + 'rem' : 0
    }
  },

  watch: {
    info (n) {
      if (n.content) {
        this.enable = 1
        const t = marshallArticle(n.content)
        this.articleBody = t
      } else {
        this.enable = 0
      }
    },

    user (n) {
      const href = `${location.protocol}//${location.host}${this.$route.fullPath}`
      new ShareMaker({
          title: this.info.title,
          introduction: this.info.shareContent || '成功并不是旅途终点，而是旅行的过程，发现一门好课赠予你。',
          link: location.href.indexOf('userId') === -1 ? location.href + '&userId=' + n.userid : location.href,
          imgUrl: this.info.shareImage,
          success: this.shareSuccess
        }, href, true)
    },

    isSelf (e) {
      
    }
  },

  methods: {
    ...mapMutations(module.name, keys(module.mutations)),
    ...mapActions(module.name, keys(module.actions)),

    openShare () {
      this.showShare = true
    },

    closeCover () {
      this.showOnceSuccess = false
      this.showShare = false
      this.showResult = false
    },

    toggleReplyPopup () {
      this.replying = !this.replying
    },

    async sendComment () {
      await this.articleComment(this.commentValue)
      window.scrollTo(0, 99999)
      this.replying = false
      this.commentValue = ''
    },

    commentPraise (resid, resindex) {
      this.praise({resid, resindex})
    },

    // 分享成功
    async shareSuccess () {
      if (!this.signed) {
        this.showOnceSuccess = true
        await this.sign()
      }

      this.showResult = true
    }
  },

  beforeCreate () {
    this.$store.registerModule(module.name, module)
  },

  created () {
    document.documentElement.style.height = 'auto'
    this.init(this.$route.query)
  },

  mounted () {
    // 目前因为新增评论的逻辑所以没有加这个分页加载，但是我想以后是应该会加的
    // const html = document.documentElement
    // document.addEventListener('scroll', async e => {
    //   if (
    //     html.clientHeight + document.body.scrollTop >= html.scrollHeight - 2 ||
    //     html.clientHeight + html.scrollTop >= html.scrollHeight - 2
    //     ) {
    //     await this.fetchComment()
    //   }
    // })
  },
  directives: {
    cut: {
      inserted: (el, binding, vnode) => {
          let { hasSubscribed } = vnode.context
          if (!hasSubscribed) {
            let showHeight = el.offsetHeight / 3
            el.style.height = `${showHeight}px`
            el.style.overflow = "hidden"
          }
      }
    }
  },
  beforeDestroy () {
    document.documentElement.style.height = '100%'
    this.$store.unregisterModule(module.name)
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../style/main";

.disableArticle {
  /*height: 100;*/
  width: 100%;

  img {
    width: 100%;
  }
}

.article {
  width: 100%;
  white-space: normal;
  word-break: break-all;
  overflow: hidden;
  &-cover {
    position: relative;
    top: rem(-100);
  }
  * {
    line-height: 1.5;
  }
  .view {
    width: 100%;
    box-sizing: border-box;
    padding: rem(33) rem(45) rem(27) rem(45);
    overflow: hidden;
  }

  img {
    width: 100%;
    border-radius: rem(10);
    margin: rem(20) 0;
  }

  h1 {
    font-size: rem(44);
    font-family: 'PingFang Sc', 'micorsoft yahei';
    line-height: rem(70);
  }

  .info {
    height: rem(62);
    color: #999;
    font-size: rem(24);
    line-height: rem(62);
    text-align: left;
  }

  .stat {
    height: rem(44);
    width: 100%;
    margin-top: rem(41);
    color: #979797;
    font-size: rem(24);
    line-height: rem(44);

    span {
      line-height: rem(44);

      &:first-child {
        float: left;
      }

      &:last-child {
        float: right;

        img {
          height: rem(29);
          width: rem(29);
          line-height: rem(44);
          vertical-align: middle;
          margin: 0;
          margin-right: rem(10);
        }

        i {
          line-height: rem(44);
          vertical-align: middle;
        }
      }
    }
  }

  hr {
    width: 100%;
    height: rem(1);
    opacity: 0;
  }

  .share {
    position: fixed;
    bottom: 0;
    left: 0;
    height: rem(120);
    width: 100%;
    border-top: rem(2) solid #F8EBDB;
    background-color: rgba(#F7F0E5, .9);

    .avatar {
      position: absolute;
      top: 0; bottom: 0;
      left: rem(25);
      margin: auto;
      height: rem(74);
      width: rem(74);
      border-radius: rem(10);
      border: rem(2) solid #fff;
    }

    .condition {
      position: absolute;
      top: 0; bottom: 0;
      left: rem(125);
      height: rem(71);
      margin: auto;
      color: #C19C6B;
      font-size: rem(24);
      line-height: rem(33);

      p {
        margin-bottom: rem(5);
        &:first-child {
          font-size: rem(22);
          color: #BA9C7C;
        }
        &:last-child {
          color: #413A36;
          font-size: rem(28);
          font-weight: bold;
        }
      }
    }

    &-btn {
      position: absolute;
      top: 0; bottom: 0;
      right: rem(23);
      height: rem(78);
      width: rem(231);
      margin: auto;
    }
  }

  .share-notself {
    position: fixed;
    bottom: 0;
    left: 0;
    height: rem(148);
    width: 100%;
    border-top: rem(2) solid #F8EBDB;
    background-color: #F7F0E5;
    &-right {
      width: rem(449);
      height: rem(148);
      float: right;
      background-color: #FEF8F0;
    }
    dl {
      position: absolute;
      top: 0; bottom: 0;
      left: rem(41);
      margin: auto;
      height: rem(68);
      color: #666;
      font-size: rem(22);
      font-weight: bold;
      line-height: rem(30);
      dt {
        max-width: rem(220);
        margin-bottom: rem(8);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        img {
          margin: 0;
          height: rem(36);
          width: rem(36);
          border-radius: 50%;
          border: rem(2) solid #fff;
          box-sizing: border-box;
          margin-right: rem(10);
          vertical-align: middle;
        }
      }
    }

    .sep {
      position: absolute;
      top: rem(21);
      left: rem(282);
      height: rem(87);
      width: rem(2);
      background-color: #EDE0CC;
    }

    .doc {
      position: absolute;
      width: rem(177);
      height: rem(105);
      top: 0; bottom: 0;
      right: rem(211);
      margin: auto;
    }

    .qr {
      position: absolute;
      top: 0; bottom: 0;
      right: rem(51);
      margin: auto;
      height: rem(120);
      width: rem(120);
    }

  }

  .cover {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2; // 要高于底部横幅
    height: 100%;
    width: 100%;
    background-color: rgba(0,0,0,.5);

    #daily {
      position: absolute;
      top: 0;
      right: rem(40);
      height: rem(929);
      width: rem(616);
    }

    #dailyOk {
      position: absolute;
      top: rem(199);
      left: rem(153);
      height: rem(603);
      width: rem(446);
    }

    #dailyCount {
      position: absolute;
      top: rem(646);
      height: rem(40);
      width: 100%;
      text-align: center;
      color: #F48F00;
      font-size: rem(28);
      font-weight: bold;
    }
  }
}
</style>
